export default __webpack_public_path__ + "static/media/pushOnline.6d2a0b29.svg";